import styled from 'styled-components';

const Container = styled.table<{ fontSize: number; offsetLeft?: number }>`
    border-spacing: 0px;
    border-collapse: separate;
    text-align: center;
    table-layout: fixed;
    width: 100%;
    height: 100%;
    overflow: hidden;
    border: 1px solid gray;
    border-collapse: collapse;
    font-size: ${({ fontSize }) => fontSize}%;

    tr {
        td,
        th {
            border: 1px solid gray;
            &:nth-child(even) {
                background-color: #d9d9d9;
            }

            ${({ offsetLeft }) =>
                !!offsetLeft &&
                `
				&:first-child {
					width: ${offsetLeft}px;
					overflow: hidden;
				};
			`}
        }
    }
    td {
        padding: 5px;
        color: #000;
        overflow-wrap: break-word;
    }
    th {
        padding: 15px 0;
        font-size: 1.1em;
        overflow-wrap: break-word;
    }
`;

const BorderedDiv = styled.div`
    height: 100%;
    border: 1px dotted black;
`;

export { BorderedDiv, Container };
